export const Service = [
  {
    id: "1",
    num: "01.",
    title: "Discovery",
    description:
      "Embark on comprehensive \n" +
      "understanding of your \n" +
      "business as we analyze the \n" +
      "needs, drivers, objectives \n" +
      "and context to identify \n" +
      "bottlenecks, pain points and \n" +
      "inefficiencies ",
    titleAR: "اكتشاف",
    descriptionAR:
      "الشروع في فهم شامل لعملك حيث نقوم بتحليل الاحتياجات والدوافع والأهداف والسياق لتحديد الاختناقات ونقاط الضعف وعدم الكفاءة",
  },
  {
    id: "2",
    num: "02.",
    title: "DESIGN",
    description:
      "RECEIVE A COMPREHENSIVE AND OPERATIONAL BLUEPRINT OF ORGANIZATIONAL DEVELOPMENT AND TRANSFORMATION (ODT) AS AN ASSET THAT YOUR ORGANIZATION USES TO ALIGN TEAMS, PROCESSES, DATA AND WORK ENVIRONMENT TO STRATEGICALLY DEVELOP AND TRANSFORM.",
    titleAR: "تصميم",
    descriptionAR:
      "الحصول على دليل شامل وعملي للتطوير التنظيمي والتحويل (ODT) كأصل تستخدمه مؤسستك لمواءمة الفرق والعمليات والبيانات وبيئة العمل للتطور والتحول الاستراتيجي",
  },
  {
    id: "3",
    num: "03.",
    title: "DEVELOPMENT",
    description:
      "OBTAIN A TEAM COLLABORATED DEVELOPMENT OF SOLUTION AND RELEVANT ASSETS THAT ADDRESS IDENTIFIED PROBLEMS AND ASPIRED RESULTS. ",
    titleAR: "تطوير",
    descriptionAR:
      "الحصول على فريق متعاون في تطوير الحلول والأصول ذات الصلة التي تعالج المشكلات المحددة والنتائج المرجوة",
  },
  {
    id: "4",
    num: "04.",
    title: "DEPLOYMENT",
    description:
      "OBSERVE THE DEPLOYMENT OF THE SOLUTION INTO YOUR ORGANIZATION’S TEAMS, PROCESSES AND WORK ENVIRONMENT, THROUGH CLEAR DELIVERABLES FOLLOWING A DEFINED TIMELINE, CONTROLS AND MEASURES.",
    titleAR: "تعيين",
    descriptionAR:
      "راقب نشر الحل في فرق مؤسستك وعملياتها وبيئة العمل ، من خلال المنجزات الواضحة بعد الجدول الزمني المحدد ، والضوابط والتدابير.",
  },
  {
    id: "5",
    num: "05.",
    title: "TRANSFORMATION",
    description:
      "EXPERIENCE THE TRANSFORMATION OF YOUR ORGANIZATION’S TEAMS, PROCESSES AND WORK ENVIRONMENT INTO A PRODUCTIVE AND SUSTAINABLE CHANGE.",
    titleAR: "تحويل",
    descriptionAR:
      "اختبر تحول فرق مؤسستك وعملياتها وبيئة العمل إلى تغيير منتج ومستدام.",
  },
  {
    id: "6",
    num: "06.",
    title: "SHIFT",
    description:
      "FEEL AND MEASURE A SHIFT IN BUSINESS PERFORMANCE, RESULTS AND THINKING AS TRANSFORMATION CHANGE FULFILLS ITS EXTENT ",
    titleAR: "التحول",
    descriptionAR:
      "اشعر وقم بقياس تحول في أداء الأعمال والنتائج والتفكير في أن التغيير يفي بمدى التغيير",
  },
];
